import CrawlForm from '../components/CrawlForm.vue';
import CrawlHistory from '../components/CrawlHistory.vue';
import CrawlStatus from '../components/CrawlStatus.vue';
import CrawlSchedules from '../components/CrawlSchedules.vue';

export default [
  {
    path: '',
    redirect: 'history',
  },
  {
    path: 'new',
    component: CrawlForm,
    meta: {
      title: 'Start Crawl',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home',
        },
        {
          path: '/web-crawl',
          title: 'Website Crawl',
        },
        {
          path: '',
          title: 'Start Crawl',
        },
      ],
    },
  },
  {
    path: 'history',
    component: CrawlHistory,
    meta: {
      title: 'Crawl History',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home',
        },
        {
          path: '/web-crawl',
          title: 'Website Crawl',
        },
        {
          path: '',
          title: 'Crawl History',
        },
      ],
    },
  },
  {
    path: 'schedules',
    component: CrawlSchedules,
    meta: {
      title: 'Crawl Schedules',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home',
        },
        {
          path: '/web-crawl',
          title: 'Website Crawl',
        },
        {
          path: '',
          title: 'Crawl Schedules',
        },
      ],
    },
  },
  {
    path: ':id',
    component: CrawlStatus,
    meta: {
      title: 'Crawl Status',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home',
        },
        {
          path: '/web-crawl',
          title: 'Website Crawl',
        },
        {
          path: '/web-crawl/history',
          title: 'Crawl History',
        },
        {
          path: '',
          title: 'Crawl Status',
        },
      ],
    },
  },
];
